<template>
  <b-container fluid>
    <b-card-body>
      <div align="center" v-if="loader">
        <img src="../assets/cargando.gif" align="center" />
      </div>
      <div v-else>
        <FormulateForm id="inicio" @submit="submitHandler" v-model="formValues">
          <center>
            <h2>Plazo Fijo Web</h2>
          </center>
          <b-row class="my-1">
            <b-col md="2"></b-col>
            <b-col md="4">
              <FormulateInput
                name="tipodoc"
                :options="{ 10: 'CUIT', 9: 'CUIL' }"
                type="select"
                label="CUIT/CUIL"
              />
            </b-col>
            <b-col md="4">
              <FormulateInput
                name="documento"
                label="Numero"
                validation="^required|number"
              />
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="2"></b-col>
            <b-col md="4">
              <FormulateInput
                name="email"
                label="Email"
                type="email"
                validation="^required|email"
              />
            </b-col>
            <b-col md="4">
              <FormulateInput
                name="confirmacion"
                label="Confirma tu Email"
                type="email"
                validation="^required|email"
              />
            </b-col>
          </b-row>
          <br />
          <b-row class="my-1">
            <b-col md="2"></b-col>
            <b-col md="4">
              <FormulateInput type="submit" name="Enviar" />
            </b-col>
          </b-row>
        </FormulateForm>
      </div>
    </b-card-body>
  </b-container>
</template>

<script>
import service from "@/logic/service.js";
export default {
  name: "Enviar",
  data() {
    return {
      formValues: {
        tipodoc: 10,
      },
      loader: false,
    };
  },
  methods: {
    async submitHandler() {
      if (this.loader) {
        return false;
      }

      if (this.formValues.email != this.formValues.confirmacion) {
        this.$alert(
          "El email ingresado no coincide con la confirmación.",
          "",
          "warning",
        );
        return false;
      }

      this.loader = true;
      const solicitud = {
        tipodoc: this.formValues.tipodoc,
        documento: this.formValues.documento,
        email: this.formValues.email,
        confirmacion: this.formValues.confirmacion,
      };

      try {
        const response = await service.register(solicitud);
        //        console.log(response);
        if (response.data.error) {
          this.loader = false;
          if (response.data.codigo == 998) {
            this.$fire({
              html: response.data.mensaje,
              type: "warning",
            });
          } else {
            this.$alert(response.data.mensaje, "", "warning");
          }
        } else {
          if (response.data.devConfirmacionUrl) {
            this.loader = false;
            const texto =
              "Solicitud validada en development.<br>" +
              `<a href="${response.data.devConfirmacionUrl}">${response.data.devConfirmacionUrl}</a>`;
            this.$fire({
              html: texto,
              title: "Importante",
              type: "success",
            });
          } else {
            const emailEnviado = response.data.emailEnviado !== false;
            const texto = emailEnviado
              ? "Estimado usuario, se ha enviado un correo a la casilla informada. Verifique su bandeja para continuar con la confirmación del plazo fijo."
              : "La solicitud quedó registrada, pero no se pudo enviar el correo. No vuelva a cargarla; comuníquese con el banco para continuar.";
            this.$alert(
              texto,
              "Importante",
              emailEnviado ? "success" : "warning",
            ).then(() => {
              window.location.href = "https://www.bancojulio.com.ar";
            });
          }
        }
      } catch (error) {
        this.loader = false;
        //        console.log(error);
        this.$alert(
          "El servicio no está disponible en este momento. Intente mas tarde.",
          "",
          "warning",
        );
      }
    },
  },
};
</script>

<style scoped>
.abs-center {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.form {
  width: 650px;
}
</style>
